function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-15942623774851327",
  d: "M10.00279,0l-0.65793,1.55556l-2.26373,5.35556l-7.08113,0.76667l5.29691,4.97778l-1.50544,7.34445l6.21132,-3.76667l6.20574,3.76667l-1.49986,-7.34445l5.29133,-4.97778l-7.07555,-0.76667z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 19.999999999999996 20.00002",
    width: 19.999999999999996,
    height: 20.00002,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.881784197001252e-16, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeWidth: 0
    },
    d: "M10.00279,0l-0.65793,1.55556l-2.26373,5.35556l-7.08113,0.76667l5.29691,4.97778l-1.50544,7.34445l6.21132,-3.76667l6.20574,3.76667l-1.49986,-7.34445l5.29133,-4.97778l-7.07555,-0.76667z",
    vectorEffect: "non-scaling-stroke"
  })), _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.8adcd499.svg";
export { ForwardRef as ReactComponent };